export default class FiltroModelliEntita{

    SitoEntita;
    FamigliaEntita;
    DescrEntita;

    constructor(sitoEntita, famigliaEntita, descrEntita){
        this.SitoEntita = sitoEntita;
        this.FamigliaEntita = famigliaEntita;
        this.DescrEntita = descrEntita;     
    }
}